export default {
    install (Vue) {
        Array.prototype.insert = function ( index, item ) {
            this.splice( index, 0, item );
        };
    }
}
